import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GiftcardsComponent } from './giftcards.component';
import { GiftcardListComponent } from './giftcard-list/giftcard-list.component';
import { GiftcardCreateComponent } from './giftcard-create/giftcard-create.component';
import { GiftcardDetailsComponent } from './giftcard-details/giftcard-details.component';
import { GiftcardCreateReturnComponent } from './giftcard-create-return/giftcard-create-return.component';

const routes: Routes = [
  {
    path: '',
    component: GiftcardsComponent,
    children: [
      {
        path: '',
        component: GiftcardListComponent,
        data: {
          title: 'Listado de Giftcards',
          id: 'Giftcards_giftcards'
        }

      },
      {
        path: 'create',
        component: GiftcardCreateComponent,
        data: {
          title: 'Crear Giftcard',
          id: 'Giftcards_giftcards'
        }

      },
      {
        path: ':code/return',
        component: GiftcardCreateReturnComponent,
        data: {
          title: 'Devolver Giftcard',
          id: 'Giftcards_giftcards'
        }

      },
      {
        path: ':code',
        component: GiftcardDetailsComponent,
        data: {
          title: 'Detalle de Giftcard',
          id: 'Giftcards_giftcards'
        }

      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GiftcardsRoutingModule { }
